import { FilmCategory } from '@vista-digital/ocapi-types/v1';
import { Validator } from '@vista-digital/validator';
export const defaultOccFilterConfig = {
    attributeIds: undefined,
    showFullAttributeName: false,
    filmCategories: [FilmCategory.NowShowing, FilmCategory.ComingSoon, FilmCategory.AdvanceBooking]
};
export const occFilterConfigValidator = Validator.object({
    attributeIds: Validator.optional(Validator.array({ minLength: 1, items: Validator.nonEmptyString })),
    showFullAttributeName: Validator.boolean(),
    filmCategories: Validator.array({
        minLength: 1,
        items: Validator.oneOf(Object.values(FilmCategory))
    })
});
//# sourceMappingURL=filter.js.map